import React, { useContext, useEffect, useState } from "react";
import "./SignUpOtp.css";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useHistory } from "react-router-dom";
import { variableContext } from "../../../../context/VariableContex";
import useAuthQuery from "../../../../store/auth/useAuthQuery";
import RegistrationErrorModal from "../../../../components/registrationModal/RegistrationErrorModal";
import white from "../../../../assets/white.png";

const SignUpOtp = () => {
  const history = useHistory();
  const { mobile } = useContext(variableContext);

  const [open, setOpen] = useState(false);
  const [value1, setValue1] = useState("");
  const [value2, setValue2] = useState("");
  const [value3, setValue3] = useState("");
  const [value4, setValue4] = useState("");

  const {
    mutateAsync: verify,
    isSuccess,
    isError,
    error,
  } = useAuthQuery.VerifyOtp();
  const {
    mutateAsync: sendOtp,
  } = useAuthQuery.SendOtp();

  const handleChange = (e, nextId, setValue) => {
    const val = e.target.value.slice(-1);
    setValue(val);
    if (val && nextId) {
      document.getElementById(nextId)?.focus();
    }
  };

  const handleKeyDown = (e, prevId) => {
    if (e.key === "Backspace" && e.target.value === "" && prevId) {
      document.getElementById(prevId)?.focus();
    }
  };

  const handleResend = async () => {
    setValue1("");
    setValue2("");
    setValue3("");
    setValue4("");
    try {
      await sendOtp({ phoneNumber: mobile });
    } catch (error) {}
  };

  const handleSubmit = async () => {
    if (value1 && value2 && value3 && value4) {
      try {
        await verify({
          mobile,
          otp: value1 + value2 + value3 + value4,
        });
      } catch (error) {}
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (isSuccess) {
      history.push("/");
    }
    if (isError) {
      setOpen(true);
    }
  }, [isError, isSuccess]);

  return (
    <>
      <div className="otp-page-wrapper">
        {/* Blue Header */}
        <div className="otp-blue-header">
          <ArrowBackIcon
            onClick={() => history.push("/sign-up")}
            className="otp-back-arrow"
          />
          <div className="otp-logo-container">
            <img src={white} className="otp-logo-img" alt="Master Click Logo" />
          </div>
        </div>

        {/* White Card */}
        <div className="otp-white-card">
          <div className="otp-title-section">
            <h1 className="otp-main-title">Enter OTP</h1>
            <p className="otp-subtitle">
              A one-time password has been sent to your WhatsApp number{" "}
              <strong>{mobile}</strong>. Please enter it below to activate your
              account.
            </p>
          </div>

          <div className="otp-wa-hint">
            <WhatsAppIcon style={{ color: "#25D366", fontSize: 18 }} />
            <span>Check WhatsApp for your OTP</span>
          </div>

          {/* OTP Inputs */}
          <div className="otp-inputs-row">
            <input
              id="otp1"
              className="otp-digit-input"
              type="number"
              maxLength={1}
              value={value1}
              onChange={(e) => handleChange(e, "otp2", setValue1)}
              onKeyDown={(e) => handleKeyDown(e, null)}
            />
            <input
              id="otp2"
              className="otp-digit-input"
              type="number"
              maxLength={1}
              value={value2}
              onChange={(e) => handleChange(e, "otp3", setValue2)}
              onKeyDown={(e) => handleKeyDown(e, "otp1")}
            />
            <input
              id="otp3"
              className="otp-digit-input"
              type="number"
              maxLength={1}
              value={value3}
              onChange={(e) => handleChange(e, "otp4", setValue3)}
              onKeyDown={(e) => handleKeyDown(e, "otp2")}
            />
            <input
              id="otp4"
              className="otp-digit-input"
              type="number"
              maxLength={1}
              value={value4}
              onChange={(e) => handleChange(e, null, setValue4)}
              onKeyDown={(e) => handleKeyDown(e, "otp3")}
            />
          </div>

          {/* Resend */}
          <p className="otp-resend-text">
            Didn't receive?{" "}
            <button className="otp-resend-btn" onClick={handleResend}>
              Resend OTP
            </button>
          </p>

          {/* Submit */}
          <Button
            className="otp-submit-btn"
            variant="contained"
            onClick={handleSubmit}
            disabled={!(value1 && value2 && value3 && value4)}
          >
            Verify &amp; Activate
          </Button>
        </div>
      </div>

      {open ? (
        <RegistrationErrorModal
          toggle={open}
          handleClose={handleClose}
          title="Error"
        />
      ) : null}
    </>
  );
};

export default SignUpOtp;
